module.exports = __webpack_public_path__ + "static/media/btn-nav-mobile.6482bd22.svg";